import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

// A plain confirmation dialog for actions with outward-facing, hard-to-undo effects (sending
// an invoice by e-mail, sending a payment reminder). It spells out what is about to happen so
// the click is deliberate. `busy` keeps it open and disabled while the action is in flight.
function ConfirmDialog({ open, title, message, confirmLabel = 'Bekräfta', cancelLabel = 'Avbryt',
                         busy = false, confirmDisabled = false, onConfirm, onCancel }: {
    open: boolean,
    title: string,
    message: React.ReactNode,
    confirmLabel?: string,
    cancelLabel?: string,
    busy?: boolean,
    // For a dialog that asks something as well as confirming: the answer is part of the message,
    // and until it is given there is nothing to confirm.
    confirmDisabled?: boolean,
    onConfirm: () => void,
    onCancel: () => void,
}) {
    return (
        <Dialog open={open} onClose={busy ? undefined : onCancel}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText component="div" sx={{ whiteSpace: 'pre-line' }}>{message}</DialogContentText>
            </DialogContent>
            {/* Cancel takes the focus, so Enter and a stray space do nothing. Everything reaching
                this dialog is outward-facing and hard to undo — an e-mail to a club, a write into
                Eventor, a booking into Visma — and none of it is worth a keystroke saved. */}
            <DialogActions>
                <Button onClick={onCancel} disabled={busy} autoFocus>{cancelLabel}</Button>
                <Button onClick={onConfirm} disabled={busy || confirmDisabled} variant="contained">
                    {busy ? <CircularProgress size="1em"/> : confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmDialog
